<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="partners.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="partner"
            :options="['settings', 'export']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :partner="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="partners.per_page"
        layout="total, prev, pager, next"
        :total="partners.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import Actions from './Actions';
import TableSettings from '../../TableSettings';
import columns, { allColumns, labels } from './columns';

export default {
  components: {
    Actions,
    TableSettings,
    ...columns,
  },
  data() {
    return {
      labels,
      allColumns,
      tableKey: 0,
      currentPage: 1,
      currentSort: {
        prop: 'name',
        order: 'ascending',
      },
    };
  },
  computed: {
    partners() {
      return this.$store.getters['partner/partners'];
    },
    tableConfig() {
      return JSON.parse(JSON.stringify(this.$store.getters['partner/tableConfig']));
    },
    loading() {
      return this.$store.getters['partner/loading'];
    },
  },
  watch: {
    tableConfig() {
      this.tableKey++;
    },
  },
  async mounted() {
    this.$store.commit('partner/setCurrentPage', this.currentPage);
    this.$store.commit('partner/setSorting', this.currentSort);
    await this.$store.dispatch('partner/fetchAll');
  },
  methods: {
    handleCurrentChange(val) {
      this.$store.commit('partner/setCurrentPage', val);
      this.$store.dispatch('partner/fetchAll');
    },
    handleSortChange({ column, prop, order }) {
      this.$store.commit('partner/setSorting', { prop, order });
      this.$store.dispatch('partner/fetchAll');
    },
  },
};
</script>

